export default __webpack_public_path__ + "static/media/s0_male.fe930bf2.wav";